module.exports = __webpack_public_path__ + "static/media/Gallary4.eaa72ec3.png";